module.exports = __webpack_public_path__ + "img/tek-torg.18178da.webp";